
import React, {useState, useEffect, useContext, useCallback} from 'react';
import PropTypes from 'prop-types';
import GlobalButton from 'GlobalComponents/GlobalButton/GlobalButton.js';
import {getWAErrorList} from 'ServerCalls/serverCalls.js';
import {QuoteMasterContext} from 'Contexts/QuoteMasterContext.js';
import styles from '../ProvidersPanel/ProvidersPanel.module.css';
import WaitingProgressLine from 'GlobalComponents/WaitingProgressLine/WaitingProgressLine.js';
import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';

export default function WAErrorLogReport({setIsWAErrorReportOpen}) {
        const {setLoading} = useContext(QuoteMasterContext);
        const [errorLogList, setErrorLogList ] = useState([]);
    
        useEffect(() => {
            if(errorLogList && errorLogList.length === 0){
                handleUpdateWAErrorList();
            }
        }, []);

    
        async function handleUpdateWAErrorList() {
            setLoading(true);
            const response = await getWAErrorList();
            if (response === 'failed') {
                console.log('Failed to get WA errors list');
                setLoading(false);
                return;
            }
            setErrorLogList(response.errorLogList);
            setLoading(false);
        }

        
    return (
        <div className={styles.providersPanel}>
            <div className={styles.providersPanelHeader}>
                <div className={styles.providersPanelButtons}>
                    <GlobalButton
                        onClick={() => setIsWAErrorReportOpen(false)}
                        label={'Fechar Log de Erros WA'}
                        width={'184px'}
                        type={'secondary'}
                    />                        
                </div>
                <div className={styles.providersPanelTitle}>Log de Erros WA</div>
                <div className={styles.providersPanelButtons}>
                    <GlobalButton 
                        onClick={handleUpdateWAErrorList} 
                        label={
                            <> 
                                <RestorePageOutlinedIcon /> 
                                <span>Atualizar Log de <br/>Erros WA</span>
                            </>
                        }
                        width={'184px'}
                        type={'secondary'}
                    />
                </div>
            </div>

            <ErrorsList errorLogList={errorLogList} setErrorLogList={setErrorLogList} />
        </div>

    )
    
}


function ErrorsList({errorLogList, setErrorLogList}) {
    const {loading} = useContext(QuoteMasterContext);
    const orderErrorList = useCallback((field) => {
            const sortedErrorLogList = [...errorLogList];
            switch(field){
                case 'serviceOrderId':
                    sortedErrorLogList.sort((a,b) => {
                        if (a.serviceOrderId > b.serviceOrderId) return 1;
                        if (a.serviceOrderId < b.serviceOrderId) return -1;
                        return 0;
                    });	
                    break;
                case 'startDate': // startDate is moment.now.format('YYYY-MM-DD HH:mm:ss')
                    sortedErrorLogList.sort((a,b) => {
                        if (a.startDate > b.startDate) return 1;
                        if (a.startDate < b.startDate) return -1;
                        return 0;
                    });
                    break;
            }
            setErrorLogList(sortedErrorLogList);
        }, [errorLogList]);

    return (
        <div className={styles.providersList}>
            <div className={styles.providersListHeader}>
                <div className={styles.userType} style={{ cursor: 'pointer' }} onClick={()=>orderErrorList('serviceOrderId')}>Ordem de Serviço</div>
                <div className={styles.userType} style={{ cursor: 'pointer' }} onClick={()=>orderErrorList('startDate')}>Data de Início</div>
                <div className={styles.userType}>Erro</div>
            </div>
            {loading && <WaitingProgressLine />}
            {errorLogList.map((error, index) => (
                <ErrorLine error={error} key={index} />
            ))}
        </div>
    )
}

function ErrorLine({error}) {
    return (
        <div className={styles.provider}>
            <div className={styles.userType}>{error.serviceOrderId}</div>
            <div className={styles.userType}>{error.createdAt}</div>
            <div className={styles.userType}>{error.errors}</div>
        </div>
    )
}


WAErrorLogReport.propTypes = {
    setIsWAErrorReportOpen: PropTypes.func.isRequired
};

